/* eslint-disable radix */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../../Core/Components/CustomRoundedImage";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import Button from "../../../Core/Components/CustomButton";
import { updateBatteries } from "../../../Redux/Slices/batteries.slice";
import {
  getAllBatteriesV3,
  getBatteryV3,
  getKPI,
  unRetireBattery,
} from "../../../Redux/APIs/batteriesAPI";
import UnRetireIcon from "../../../Common/Svgs/UnRetireIcon";

const LOCAL_DEFAULT_LIMIT = 10;

const UnretireBatteryModal = ({
  visible,
  onCancel,
  batteryCurrentPage,
  setBatteryCurrentPage,
}) => {
  const dispatch = useDispatch();

  const { currentBattery } = useSelector((state) => state.batteries);

  const onConfirm = async () => {
    await dispatch(unRetireBattery({ batteryId: currentBattery.id }));

    const response = await dispatch(
      getBatteryV3({
        offset: ((batteryCurrentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
      }),
    );

    // If no records exist for the current page, move to the previous page
    if (!response.payload.result.length && batteryCurrentPage > 1) {
      const previousPage = batteryCurrentPage - 1;
      setBatteryCurrentPage(previousPage);

      await dispatch(
        getBatteryV3({
          offset: (previousPage - 1) * LOCAL_DEFAULT_LIMIT,
        }),
      );
    }

    dispatch(getKPI());
    dispatch(getAllBatteriesV3());

    dispatch(
      updateBatteries({
        key: "showToastMessage",
        value: {
          visible: true,
          data: {
            title: "1 Battery Un-Retired",
            description: `Battery ${
              currentBattery?.registrationNo || "1 battery"
            } was un-retired sucessfully.`,
          },
        },
      }),
    );

    onCancel();
  };

  const getBody = () => {
    return (
      <div className="px-2 mt-5">
        <p className="text-base font-medium text-black font-poppins">
          Un-Retire battery
        </p>
        <p className="mt-2 text-xs font-normal text-black font-aileron">
          Are you sure you want to un-retire this battery?
        </p>
      </div>
    );
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <CustomRoundedImage
            size="w-12 h-12"
            image={<UnRetireIcon size={24} className="text-white" />}
            background="bg-primary"
          />
          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        {getBody()}

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>

          <Button colors="primary" size="primary" onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default UnretireBatteryModal;
